import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { ModalComponent } from "../../modal/modal.component";
import { DBAttendeeReservation } from "./attendance.service";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { s25Resource } from "../../../util/s25.resource";
import { UserprefService } from "../../../services/userpref.service";
import { S25PipesModule } from "../../../pipes/s25.pipes.module";
import { ModalHeaderComponent } from "../../modal/modal.header.component";

@Component({
    standalone: true,
    template: `
        <s25-modal-header [data]="data"></s25-modal-header>
        <div class="modal-body">
            <div>This action will result in the following registration requests being cancelled</div>
            <ul>
                @for (occ of data.occurrences; track occ.reservationId) {
                    <li>{{ occ.reservationStart | dateFormat: dateTimeFormat.value() }}</li>
                }
            </ul>
            <div class="question">Do you wish to continue?</div>
            <div class="modal-footer">
                <s25-ng-button [type]="'outline'" (clicked)="data.closeModal(false)">No</s25-ng-button>
                <s25-ng-button [type]="'primary'" (clicked)="data.closeModal(true)">Yes</s25-ng-button>
            </div>
        </div>
    `,
    styles: `
        .modal-body {
            display: grid;
            gap: 0.5rem;
        }

        .question {
            font-weight: bold;
        }

        .modal-footer {
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent, S25PipesModule, ModalHeaderComponent],
})
export class ConfirmCancelRegistrationModalComponent extends ModalComponent<{
    occurrences: DBAttendeeReservation[];
    closeModal: (yes: boolean) => void;
}> {
    readonly dateTimeFormat = s25Resource({ loader: UserprefService.getS25DateTimeformat });
}
